import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'fileSize',
})
export class FileSizePipe implements PipeTransform {
	public transform(fileSize: number | null | undefined): string {
		let value = fileSize;
		if (value === null || value === undefined) {
			return '-';
		}

		if (isNaN(value)) {
			value = 0;
		}

		if (value < 1024) {
			return value + ' Bytes';
		}

		value /= 1024;

		if (value < 1024) {
			return value.toFixed(2) + ' Kb';
		}

		value /= 1024;

		if (value < 1024) {
			return value.toFixed(2) + ' Mb';
		}

		value /= 1024;

		if (value < 1024) {
			return value.toFixed(2) + ' Gb';
		}

		value /= 1024;

		return value.toFixed(2) + ' Tb';
	}
}
